"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var pick = require('lodash/pick');
var pickBy = require('lodash/pickBy');
/**
 * The Model class in all its' glory.
 */
var Model = /** @class */ (function () {
    /**
     * If attributes are specified, `set` is called along with the model options.
     */
    function Model(attributes, options) {
        this.set = mobx_1.action('set', this.set.bind(this));
        // Just in case we have a root store,
        // set it so we don't need the initialize pattern.
        if (options && options.rootStore) {
            ;
            this.rootStore = options.rootStore;
        }
        if (attributes) {
            this.set(attributes, options);
        }
    }
    /**
     * Sets the attributes on the model, optionally calling `parse` first.
     */
    Model.prototype.set = function (attributes, options) {
        if (options) {
            if (options.parse && this.parse) {
                attributes = this.parse(attributes, options);
            }
            if (options.stripUndefined) {
                // Strip out any undefined keys.
                attributes = pickBy(attributes, function (prop) { return prop !== undefined; });
            }
        }
        Object.assign(this, attributes);
        return this;
    };
    /**
     * Used to convert a raw object to something more meaningful.
     */
    Model.prototype.parse = function (attributes, options) {
        return attributes;
    };
    /**
     * Picks properties and returns them as an object.
     */
    Model.prototype.pick = function (properties) {
        // No guarantees that what is returned actually matches
        // the given TypeScript generic.
        return pick(this, properties);
    };
    return Model;
}());
exports.Model = Model;
/**
 * Creates (or enhances) an object with Model capabilities.
 *
 * @param target Optional target object to enhance. Defaults to a new one.
 */
function model(target) {
    target = target || {};
    target = Object.assign(target, {
        set: mobx_1.action('set', Model.prototype.set.bind(target)),
        pick: Model.prototype.pick.bind(target),
        parse: target.parse || Model.prototype.parse.bind(target),
        assign: Object.assign.bind(null, target),
        extendObservable: mobx_1.extendObservable.bind(null, target),
        withActions: withActions.bind(target),
        decorate: decorate.bind(target)
    });
    return target;
}
exports.model = model;
/**
 * Attaches `actions` to ´this`.
 *
 * @param this Object to attach actions to.
 * @param actions Object with actions to attach. Each value is passed to ´action` and bound.
 */
function withActions(actions) {
    for (var key in actions) {
        // istanbul ignore else
        if (Object.prototype.hasOwnProperty.call(actions, key)) {
            var prop = actions[key];
            /*tslint:disable-next-line*/
            if (typeof prop !== 'function') {
                throw new Error('The object passed to withActions should only contain ' +
                    ("functions, but found " + key + ": " + typeof prop));
            }
            ;
            this[key] = mobx_1.action(key, prop.bind(this));
        }
    }
    return this;
}
/**
 * Invokes the method that will decorate the passed-in model.
 *
 * @param fn Function to invoke passing in the model as the first parameter.
 */
function decorate(fn) {
    fn(this);
    return this;
}
//# sourceMappingURL=model.js.map